import React, { useState, useEffect } from "react";
import "../deliveryTerms/DeliveryTerms.scss";
import { useNavigate } from "react-router-dom";
import FetchData, { DeleteEntry, GetList } from "../../providers/dataProvider";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import useForm from "./useForm";
import DataSearch from "../../utils/DataSearch";
import { useRolePermission } from "../../hooks/useRolePermission";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DeleteModal from "../../components/common/DeleteModal";
import DataTable from '../../components/common/DataTable';
import ErrorMessage from '../../components/common/ErrorMessage';
import { CheckNull } from '../../utils/Validate';
import DeliveryTermsGrid from "../../components/deliveryNote/DeliveryTermsGrid";
import { SearchComponent } from "../../components/common/SearchComponent";

const DeliveryTermsList = () => {
  const [deliveryTermsData, setDeliveryTermsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [deleteShow, setDeleteShow] = useState({ show: false, item: "", title: '', textCode: '', text: '', loading: false });
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState([]);
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [filterColumn, setFilterColumn] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: ""
  });
  const [createMsg, setCreateMsg] = useState(null);
  const [show, setShow] = useState(false);
  const [listData, setListData] = useState({});
  const [transportModes, setTransportModes] = useState([]);

  const { menuRights } = useRolePermission("Delivery Terms")


  const { data: deliveryTermsList, loading: loadingList } = FetchData("deliveryterms");
  const { data: transportModeList } = FetchData("deliverymodes");

  useEffect(() => {
    if (transportModeList) setTransportModes(transportModeList);
  }, [transportModeList]);

  const SuccessDoneClick = () => {
    setShow(false);
    if (createMsg?.message == "Delivery terms deleted successfully")
      GetList("deliveryterms", "", setListData);
    else navigate("/delivery-terms");
  };

  const baseColumns = [
    {
      heading: "Abbreviation",
      value: "abbreviation",
      sortable: true,
    },
    {
      heading: "Delivery Terms",
      value: "deliveryDescription",
      sortable: true,
    },
    {
      heading: "Description",
      value: "termsTooltip",
      sortable: true,
    },
    {
      heading: "Status",
      value: "status",
      sortable: true,
    },
  ];


  useEffect(() => {
    let filterdata = deliveryTermsData.map((filterItem, index) => {
      filterItem.status = filterItem.isActive === true ? "Active" : "Inactive";
      filterItem['view'] = menuRights?.canView === true ? 'VIEW' : 'NOT-VIEW';
      return filterItem;
    });
    filterdata = [...filterdata]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    if (search != '') ApplySearch()
    else setTableData(filterdata)
  }, [deliveryTermsData, menuRights]);

  useEffect(() => {
    if (deliveryTermsList) setDeliveryTermsData(deliveryTermsList);
  }, [deliveryTermsList])

  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [selected]);

  const handleEdit = (item) => {
    if (item)
      navigate("/add-delivery-terms", {
        state: {
          row: item,
          id: item?.id,
          canAdd: menuRights?.canAdd,
          canEdit: menuRights?.canEdit
        },
      });
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: 'You want delete this Delivery Terms?',
      textCode: 'Delivery Terms',
      text: item?.abbreviation,
      loading: false
    })
  };

  const handleCancelDelete = () => {
    setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
  };

  const ErrorDoneClick = () => {
    setErrorShow({ show: false, errorMessage: "" })
    setCreateMsg(null);
  }

  const handleConfirmDelete = (item) => {
    setDeleteShow({ ...deleteShow, loading: true })
    DeleteEntry("deliveryterms", item, setCreateMsg, "Delivery terms deleted successfully", "Failed to delete delivery term");
  };

  useEffect(() => {
    if (createMsg?.successData === "Successful") {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
        setShow(true);
      }
    } else {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
        setErrorShow({ show: true, errorMessage: createMsg.message })
        setShow(false);
      }
    }
  }, [createMsg]);

  const ApplySearch = () => {
    let SearchResult = [];
    SearchResult = DataSearch(deliveryTermsData, search, baseColumns);
    SearchResult = [...SearchResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt)
    });
    setTableData(SearchResult)
    setRefreshSearch(false)
  };

  useEffect(() => {
    if (refreshSearch === true) ApplySearch();
  }, [search])

  const RefreshList = () => { window.location.reload() }

  useEffect(() => {
    if (listData?.message == "success") {
      setDeliveryTermsData(listData?.data)
    }
  }, [listData])

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') { ApplySearch() }
  };

  const addNew = () => {
    navigate('/add-delivery-terms', {
      state: {
        canAdd: menuRights?.canAdd,
        canEdit: menuRights?.canEdit
      }
    })
  }
  const handleClose = () => setShowModal(false);

  const handleView = (item) => {
    if (menuRights?.canView) {
      let tempArr = [];
      const itemCopy = { ...item }
      const modeValues = itemCopy?.modeofTransports?.split(",").map((ob) => parseInt(ob));
      transportModes?.map((obj) => {
        if (modeValues?.includes(obj?.id)) tempArr.push(obj?.transportationMode);
      })
      itemCopy['modeValue'] = tempArr.join('/');
      setShowModal(itemCopy)
    }
  }

  const removeSearch = () => {
    setSearch("");
    setRefreshSearch(true)
  }

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked
    if (activeData == false) {
      setSelected(oldData => [...oldData, e.target.value])
    } else {
      setSelected(selected.filter(values => values !== e.target.value))
    }
  };
  return (
    <>
      <section id="deliveryTermsList">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
              <div className="card quote-toolbar-card">
                <div className="card-body">
                  <div className="row search-area-row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                      <div>
                        <p>{tableData?.length} Results Found</p>
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 p-0">
                      <SearchComponent
                        filteredResults={tableData}
                        search={search}
                        handleKeyDown={handleKeyPress}
                        setSearch={setSearch}
                        removeSearch={removeSearch}
                        ApplySearch={ApplySearch}
                        RefreshList={RefreshList}
                        baseColumns={baseColumns}
                        selected={selected}
                        handleChange={handleChange}
                        data={deliveryTermsList}
                        addNew={addNew}
                        HideFilter="HideFilter"
                        menuRights={menuRights} />
                    </div>
                  </div>
                  {/* <!-- search-area-sec ends --> */}
                </div>
              </div>
            </div>
          </div>

          <DeliveryTermsGrid
            filteredResults={tableData}
            filterColumn={filterColumn}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            loading={loadingList}
            menuRights={menuRights}
            moduleName='deliveryterms' />

        </div>
      </section>
      <DeleteModal deleteShow={deleteShow} handleCancelDelete={handleCancelDelete} handleConfirmDelete={handleConfirmDelete} />
      <ErrorMessage Show={errorShow?.show} errorMessage={errorShow?.errorMessage} ErrorDoneClick={ErrorDoneClick} />
      <SaveSuccessModel show={show} createMsg={createMsg} setShow={setShow} SuccessDoneClick={SuccessDoneClick} />

      {/* delivery-terms-view-modal start */}
      <Modal show={showModal} onHide={handleClose} animation={false} centered className='delivery-terms-view-modal' size="xl">
        <Modal.Header>
          <h5 className="modal-title">{showModal?.abbreviation}</h5>
          <i className="fas fa-times" onClick={handleClose}></i>
        </Modal.Header>
        <Modal.Body>
          <div className='row mt-3'>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Abbreviation</h5>
                <h6>{showModal?.abbreviation}</h6>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Delivery Terms</h5>
                <h6>{showModal?.deliveryDescription}</h6>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Mode of Transport</h5>
                <h6>{showModal?.modeValue}</h6>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Country</h5>
                <h6>{showModal?.countryRequired ? 'Required' : 'Not Required'}</h6>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Destination</h5>
                <h6>{showModal?.destinationRequired ? 'Required' : 'Not Required'}</h6>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Description (Tool Tips)</h5>
                <h6>{showModal?.termsTooltip}</h6>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
              <div>
                <h5>Status</h5>
                <h6>{showModal?.isActive ? 'Active' : 'InActive'}</h6>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Back
          </Button>
        </Modal.Footer>
      </Modal>
      {/* delivery-terms-view-modal end */}

    </>
  );
};

export default DeliveryTermsList;